import {createRegistry} from '@Components/ai-chat-window/lib/create-registry';
import type {ComponentAction} from './component-action.types';
import {connectSocialAccountAction} from './connect-social-account.action';
import {reconnectSocialAccountAction} from './reconnect-social-account.action';

const REGISTRY = createRegistry([connectSocialAccountAction, reconnectSocialAccountAction], (action) => action.actionType);

export const getComponentAction = (actionType: string): ComponentAction | undefined => REGISTRY[actionType];
